export const HearingAWS = "https://hearing-app.s3.ca-central-1.amazonaws.com/";
export const LiteracyAppAWS = "https://literacy-app-video.s3.ca-central-1.amazonaws.com/";
export const ImageProcessingAWS = "https://image-process-bucket.s3.ca-central-1.amazonaws.com/";